module.exports = __webpack_public_path__ + "img/sld_scb_21_t1_b1_green.91f7dcc3.svg";